import { computed, makeObservable } from 'mobx';
import { Common } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { calculateRaceStatus, RaceViewStatusType } from 'src/domains/sportsbook/utils/filterRacesWithFinishState';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';

export class RaceDetailsState {
    public constructor(
        public readonly common: Common,
        public readonly eventId: EventId
    ) {
        makeObservable(this);
    }

    @computed public get race(): EventModel | null {
        return this.eventId.getEventModel();
    }

    @computed public get isLoading(): boolean {
        const race = this.race;
        if (race === null) {
            return true;
        }

        return race.marketRaceWinnerAll.length === 0 && race.marketTrapChallenge.length === 0;
    }

    @computed public get raceStatus(): RaceViewStatusType | null {
        const race = this.race;
        if (race === null) {
            return null;
        }

        return calculateRaceStatus(race.timeSettingsTimeline, race.state);
    }

    @computed public get isFinishedRace(): boolean {
        return this.raceStatus === 'RaceStatusFinished';
    }

    @computed public get isRaceInProgress(): boolean {
        return this.raceStatus === 'RaceStatusInProgress';
    }

    @computed public get hasStream(): boolean {
        const race = this.race;
        if (race === null) return false;

        const configComponents = ConfigComponents.get(this.common);
        const streamingState = StreamingState.get(this.common);

        const isLiveStreamingEnabled = configComponents.config.hasEventLiveStreaming;
        const isStreamAvailable = streamingState.hasStream(race.id);

        return isLiveStreamingEnabled && isStreamAvailable;
    }
}
